module.exports = __webpack_public_path__ + "static/media/viking.1194fac4.jpg";